import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'

import { routes as accessRoutes } from '@/features/access'
import { routes as engineRoutes } from '@/features/engines'
import { routes as guardrailRoutes } from '@/features/guardrails'
import { routes as placeholderRoutes } from '@/features/placeholders'
import { routes as priceFetchRoutes } from '@/features/price-fetch'

import { useSessionStore } from './session-store'

/** The page `/` opens after launch. Dynamic Engines for now; Performance later. */
export const LANDING_ROUTE = 'engines'

// Rule FE-ARCH-03: src/app is the composition root. It assembles each feature's routes
// through the feature's index and never reaches into a feature's files.
export const router = createRouter({
  // Routes start at /; only the built assets live under /build/.
  history: createWebHistory('/'),
  routes: [
    ...engineRoutes,
    ...priceFetchRoutes,
    ...guardrailRoutes,
    ...placeholderRoutes,
    ...accessRoutes,
  ],
})

/**
 * Sends a visitor without a session to the signed-out page at /, and a signed-in user from /
 * to the landing page. Guards never fetch.
 */
export function requireSession(to: RouteLocationNormalized) {
  const signedIn = useSessionStore().status === 'signed-in'
  if (to.name === 'signed-out') return signedIn ? { name: LANDING_ROUTE } : true
  if (to.meta.public) return true
  return signedIn ? true : { name: 'signed-out' }
}

router.beforeEach(requireSession)

router.afterEach((to) => {
  const title = typeof to.meta.title === 'string' ? to.meta.title : ''
  document.title = title ? `${title} · revUP` : 'revUP'
  const main = document.getElementById('main')
  main?.focus()
})
